module.exports = __webpack_public_path__ + "static/media/MrTan_IreneTan_Airport.18f1123a.png";